import { useState, useEffect } from "react";

export default function ReadingProgressBar({
  placement = "bottom",
  color = "#216497",
  height = "5px",
  startSelector = "article",
  endSelector = '[class*="temas-container"]',
}) {
  const [progress, setProgress] = useState(0);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (placement === "top") {
      const header = document.querySelector('[class*="header-container"]');
      if (header) setOffset(header.offsetHeight);
    }

    const fn = () => {
      const startEl = document.querySelector(startSelector);
      const endEl = document.querySelector(endSelector) || startEl;
      if (!startEl || !endEl) return;

      const startTop = startEl.getBoundingClientRect().top + window.scrollY;
      const endBottom = endEl.getBoundingClientRect().top + window.scrollY + endEl.offsetHeight;
      const viewportHeight = document.documentElement.clientHeight;
      const scrollable = endBottom - viewportHeight - startTop;

      if (scrollable <= 0) return;

      const pct = (window.scrollY - startTop) / scrollable * 100;
      setProgress(Math.min(100, Math.max(0, pct)));
    };

    window.addEventListener("scroll", fn, { passive: true });
    fn();
    return () => window.removeEventListener("scroll", fn);
  }, [placement, startSelector, endSelector]);

  const positionStyle = placement === "bottom"
    ? { bottom: 0 }
    : { top: `${offset}px` };

  return (
    <div
      aria-hidden="true"
      title={`Porcentaje de lectura ${Math.round(progress)}%`}
      style={{ position: "fixed", left: 0, width: "100%", height, zIndex: 99999, cursor: "default", ...positionStyle }}
    >
      <div style={{ height: "100%", width: `${progress}%`, backgroundColor: color, transition: "width 0.4s ease-out", pointerEvents: "none" }} />
    </div>
  );
}
